import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { message, Button, Icon } from 'antd'
import Animate from 'rc-animate'

import { Creators as authActions } from '../../../appRedux/ducks/auth/auth'
import Navbar from '../components/Navbar/Navbar'
import { PhoneInput } from '../components'
import PortalLogo from '../../../assets/images/portal-logo-purple.svg'
import PhonePin from '../../../assets/images/phone-pin.svg'
import PencilIcon from './PencilIcon'
import { getMessage } from '../../../util/IntlMessages'
import { request } from '../../../util/handlerRequestUtil'
import * as api from '../../../services/api'
import './Styles.css'

const PinValidation = ({ history }) => {
  const dispatch = useDispatch()
  const [code, setCode] = useState('')
  const [showPhoneNumberForm, setShowPhoneNumberForm] = useState(false)
  const EditIcon = (props) => <Icon component={PencilIcon} {...props} />

  const buttonEditCel = (
    <Button className="default-actionContent-button" type="link">
      <EditIcon style={{ fontSize: '32px' }} />
    </Button>
  )

  function handleOnChange({ target }) {
    setCode(target.value)
  }

  async function handleSubmit() {
    if (code.length !== 6) {
      message.error(getMessage('landing-page.pin-validation.error'))
      return
    }
    const appStorage = window.localStorage
    const phoneNumber = appStorage.getItem('phone')
    if (phoneNumber) {
      const params = {
        phone: phoneNumber,
        pinCode: code
      }

      const response = await request(api.validatePin(params), false, true).catch(() => {
        message.error(getMessage('landing-page.pin-validation.error'))
      })
      if (response && response.token) {
        appStorage.clear()
        appStorage.setItem('entitlements', response.entitlements)
        dispatch(
          authActions.success({
            ...response,
            phone: phoneNumber
          })
        )
        history.push('/farmers/reports')
      }
    } else {
      message.error(getMessage('landing-page.pin-validation.error'))
    }
  }

  async function handleResendPinButton() {
    const appStorage = window.localStorage
    const phoneNumber = appStorage.getItem('phone')
    if (phoneNumber) {
      const response = await sendPin(phoneNumber)
      if (response.status === 200) {
        message.success(getMessage('landing-page.resend-pin-success'))
      }
    } else {
      message.error(getMessage('landing-page.pin-validation-phone.error'))
    }
  }

  async function handleEditPhoneNumberSubmit(value) {
    const response = await sendPin(value)
    if (response.status === 200) {
      const appStorage = window.localStorage
      appStorage.setItem('phone', value)
      message.success(getMessage('landing-page.resend-pin-success'))
      setShowPhoneNumberForm(false)
    }
  }

  async function sendPin(phone) {
    const params = {
      phone
    }
    return request(api.sendPin(params))
  }

  const phoneNumberForm = (
    <div className="margin-top">
      <div className="form-control phone-input-width">
        <PhoneInput
          handleSubmit={handleEditPhoneNumberSubmit}
          confirmButton={buttonEditCel}
          title={getMessage('landing-page.change-phoneNumber.label')}
          placeholder="(00) 0000-0000"
          inputStyle={{ width: '50%' }}
        />
      </div>
    </div>
  )

  return (
    <div className="pin-validation">
      <div className="desktop-navbar">
        <Navbar />
      </div>

      <div className="container">
        <img className="logo-portal" src={PortalLogo} alt="portal-logo" />

        <div className="content">
          <img className="phone-pin" src={PhonePin} alt="phone-pin" />

          <div className="wrapper">
            <p className="title">{getMessage('landing-page.validation-title')}</p>
            <label className="label">{getMessage('landing-page.validation-sub-title')}</label>

            <div className="form-control">
              <input className="input" type="tel" placeholder="Digite aqui" value={code} onChange={handleOnChange} />
              <button className="button" onClick={handleSubmit}>
                {getMessage('continue')}
              </button>
            </div>
            <div className="margin-top">
              <div className="form-control">
                <Button
                  style={{
                    borderColor: '#843EF7',
                    color: '#843EF7',
                    borderRadius: 2
                  }}
                  onClick={() => handleResendPinButton()}
                >
                  {getMessage('landing-page.validation.resend-pin-button.label')}
                </Button>
                <Button
                  style={{
                    borderColor: '#843EF7',
                    color: '#843EF7',
                    borderRadius: 2
                  }}
                  onClick={() => setShowPhoneNumberForm(!showPhoneNumberForm)}
                >
                  {getMessage('landing-page.validation.change-phone-button.label')}
                </Button>
              </div>
            </div>
            <Animate transitionName="fade" transitionAppear>
              {showPhoneNumberForm ? phoneNumberForm : null}
            </Animate>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PinValidation
